<template>
  <div>
    <v-card class="rounded-lg">
      <v-form @submit.prevent="activeSearchForm" ref="form" class="pa-4">
        <div class="banner elevation-1">
          <h4>{{ $t("titles.pcr_data") }} - {{ patientDescription }}:</h4>
        </div>

        <v-row dense>
          <v-col class="d-flex mt-2" cols="12" sm="12">
            <v-textarea
              data-cy="historia-clinica"
              color="#086318"
              :counter="2000"
              :rules="[minMaxRule]"
              class="rounded-lg"
              row-height="15"
              rows="7"
              outlined
              dense
              v-model="resource.clinical_historic"
            >
              <template v-slot:label>
                {{ $t("inputs.pcr_donor_data.clinical_historic") }}
                <span style="color: red">*</span>
              </template>
            </v-textarea>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-text-field
              data-cy="data-pcr"
              color="#086318"
              :rules="formRules"
              v-model="resource.pcr_date"
              class="rounded-lg"
              type="date"
              :max="maxDate"
              outlined
              dense
            >
              <template v-slot:label>
                {{ $t("inputs.pcr_donor_data.pcr_date") }}
                <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-text-field
              data-cy="hora-pcr"
              color="#086318"
              :label="$t('inputs.pcr_donor_data.pcr_hour')"
              type="time"
              :rules="formRules"
              class="rounded-lg"
              v-model="resource.pcr_hour"
              outlined
              dense
            >
              <template v-slot:label>
                {{ $t("inputs.pcr_donor_data.pcr_hour") }}
                <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-select
              data-cy="corpo-resfriado"
              :items="yesOrNot"
              :rules="formRules"
              color="#086318"
              item-value="value"
              item-text="name"
              class="rounded-lg"
              dense
              outlined
              v-model="resource.cold_body"
            >
              <template v-slot:label>
                {{ $t("inputs.pcr_donor_data.cold_body") }}
                <span style="color: red">*</span>
              </template>
            </v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-text-field
              color="#086318"
              class="rounded-lg"
              v-model="resource.ending_pme_date"
              :label="$t('inputs.pcr_donor_data.ending_pme_date')"
              type="date"
              :max="maxDate"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-text-field
              color="#086318"
              class="rounded-lg"
              type="time"
              v-model="resource.ending_pme_hour"
              :label="$t('inputs.pcr_donor_data.ending_pme_hour')"
              outlined
              dense
            >
            </v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4">
            <v-autocomplete
              data-cy="causa-obito"
              :items="cause_of_death"
              item-value="id"
              item-text="description"
              color="#086318"
              :rules="formRules"
              class="rounded-lg"
              :label="$t('inputs.pcr_donor_data.cause_of_death')"
              v-model="resource.cause_of_death_id"
              outlined
              dense
            >
              <template v-slot:label>
                {{ $t("inputs.pcr_donor_data.cause_of_death") }}
                <span style="color: red">*</span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <p class="space-personalized"></p>
        <div class="buttons" style="margin-bottom: 10px">
          <v-row class="d-flex justify-end pr-4" no-gutters>
            <v-col class="d-flex mb-1 mr-1" cols="12" sm="auto">
              <BackToGridBtn />
            </v-col>
            <v-col class="d-flex" cols="12" sm="auto">
              <v-btn
                data-cy="btn-save-pcr-morte"
                class="rounded-lg"
                elevation="0"
                block
                color="#41916b"
                @click="pcrDeathData()"
              >
                <span class="textBtn" style="color: white">{{
                  $t("buttons.save")
                }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import dateTimeLimit from "@/utils/dateTimeLimit";
import currentUser from "@/utils/currentUser";
import Formatters from "@/utils/Formatters";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      yesOrNot: [
        {
          name: "Sim",
          value: "1",
        },
        {
          name: "Não",
          value: "2",
        },
      ],
      formRules: [(v) => !!v || "Este campo é obrigatório"],
      cause_of_death: [],
    };
  },

  components: {
    BackToGridBtn,
  },

  props: {
    patientName: String,
  },

  computed: {
    ...mapGetters({
      patientData: "getPatientData",
      pcrPatientData: "getPCRDonorData",
      resource: "getPCRDeathData",
      donor_id: "getDonorId",
    }),

    maxDate() {
      const now = new Date();
      return now.toISOString().slice(0, 10);
    },

    userData() {
      return currentUser.getUserData();
    },

    patientDescription() {
      return this.resource.name ?? this.patientData.name;
    },
  },

  watch: {
    resource: {
      handler(item) {
        item.cause_of_death_id
          ? (this.resource.cause_of_death_id = parseInt(item.cause_of_death_id))
          : null;
      },
      immediate: true,
    },
  },

  mounted() {
    this.getFields();
  },

  methods: {
    ...mapActions([
      "changeForPCRPatientData",
      "changePCRDeathData",
      "changeSnackBarData",
    ]),

    minMaxRule(value) {
      const minLength = 10;
      const maxLength = 2000;

      if (!value) {
        return "O campo é obrigatório.";
      } else if (value.length < minLength) {
        return `O campo deve ter pelo menos ${minLength} caracteres.`;
      } else if (value.length > maxLength) {
        return `O campo deve ter no máximo ${maxLength} caracteres.`;
      }

      return true;
    },

    onlyDateInput(path, field, value) {
      this[path][field] = dateTimeLimit.limiteInputOnlyDate(value);
    },
    getFields() {
      axios.get(`/cause_of_deaths`).then((response) => {
        this.cause_of_death = response.data.data;
      });
    },

    pcrDeathData() {
      if (this.$refs.form.validate()) {
        this.resource.donor_id = this.patientData.id
          ? this.patientData.id
          : this.donor_id;
        this.patientData.id = this.resource.donor_id
          ? this.resource.donor_id
          : this.donor_id;

        this.resource.pickup = null;
        this.resource.user_id = this.userData.id;

        const data = { ...this.resource };
        axios({
          method: this.resource.id ? "PUT" : "POST",
          url: this.resource.id
            ? `/pcr_donor_data/${this.resource.id}`
            : `/pcr_donor_data`,
          data,
        })
          .then((response) => {
            this.$refs.form.reset();
            this.changePCRDeathData(response.data.id);
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "success",
              titleIcon: "mdi-check-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
              this.$router.push({ path: "/validacao-doador-pcr" });
            }, 2000);
          })
          .catch((err) => {
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: this.$t("messages.something_went_wrong"),
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },

  beforeDestroy() {
    this.changePCRDeathData({}), this.$refs.form.reset();
  },
};
</script>
<style scoped>
.banner {
  background: #b3ffab;
  background: -webkit-linear-gradient(to right, #41916b, #1abc9c);
  background: linear-gradient(to right, #41916b, #b8e0cd);

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner > h4 {
  color: #ffffff;
  padding: 10px;
}
</style>
